// extracted by mini-css-extract-plugin
module.exports = {"infoListBlock":"InfoList_infoListBlock__1XQio","nameBlock":"InfoList_nameBlock__-8dL0","infoList":"InfoList_infoList__2uExJ","infoItem":"InfoList_infoItem__16-eb"};